const { createSlice } = require('@reduxjs/toolkit');

const productPageSlice = createSlice({
    name: "productPage",
    initialState: {
        productPageNo: 1
    },
    reducers: {
        setproductPage(state, action) {
            const productPageNo = action.payload;

            return state = {
                productPageNo
            };
        }
    },
});

export const { setproductPage } = productPageSlice.actions;
export default productPageSlice.reducer;